<template>
  <div class="box">

    <p>
      浦东新区人才服务中心受理《上海市居住证》积分材料上传系统（以下简称：积分材料上传系统）尊重并保护所有使用积分材料上传系统网络服务用户的个人隐私权。 为了给您提供更准确、更有个性化的服务，积分材料上传系统会按照本隐私权政策的规定使用您的个人信息。但积分材料上传系统将以高度的勤勉、审慎义务对待这些信息。
    </p>
    <p>
      除本隐私权政策另有规定外，在未征得您事先许可的情况下，积分材料上传系统不会将这些信息对外披露或向第三方提供。积分材料上传系统会不时更新本隐私权政策。 您在同意积分材料上传系统网络服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于积分材料上传系统网络服务使用协议不可分割的一部分。     
    </p>
    <p><strong>1.适用范围</strong> </p>
    <p>
      a) 在您注册积分材料上传系统帐号时，您根据积分材料上传系统要求提供的个人注册信息（应法律法规要求需公示的单位名称及相关工商注册信息除外）；</p>
    <p>
      b) 在您使用积分材料上传系统服务，或访问积分材料上传系统平台网页时，积分材料上传系统自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；</p>
    <p>
      c) 积分材料上传系统通过合法途径从相关部门取得的用户个人数据。</p>
    <p>您了解并同意，以下信息不适用本隐私权政策： </p>
    <p>
      a) 您在使用积分材料上传系统网平台提供的搜索服务时输入的关键字信息；
    </p>
    <p>
      b) 积分材料上传系统收集到的您在积分材料上传系统上传的有关信息数据；
    </p>
    <p>
      c) 违反法律规定或违反积分材料上传系统规则行为及积分材料上传系统已对您采取的措施。
    </p>
    <p><strong>2. 信息使用</strong> </p>
    <p>
      a) 积分材料上传系统不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和积分材料上传系统单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。
    </p>
    <p>
      b) 积分材料上传系统亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何积分材料上传系统平台用户如从事上述活动，一经发现，积分材料上传系统有权立即终止与该用户的服务协议。
    </p>
    <p>
      c) 为服务用户的目的，积分材料上传系统可能通过使用您的个人信息，向您提供办理该业务的相关信息。
    </p>
    <p><strong>3. 信息披露</strong> </p>
    <p>
      在如下情况下，积分材料上传系统将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：
    </p>
    <p>
      a) 经您事先同意，向第三方披露；
    </p>
    <p>
      b) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；
    </p>
    <p>
      c) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；
    </p>
    <p>
      d) 如您出现违反中国有关法律、法规或者积分材料上传系统服务协议或相关规则的情况，需要向第三方披露；
    </p>
    <p>
      e) 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；
    </p>
    <p>
      f) 在积分材料上传系统平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，积分材料上传系统有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。
    </p>
    <p>
      g) 其它积分材料上传系统根据法律、法规或者网站政策认为合适的披露。
    </p>
    <p><strong>4. 信息存储</strong> </p>
    <p>
      积分材料上传系统收集的有关您的信息和资料将保存在浦东新区人才服务中心的服务器上。
    </p>
    <p><strong>5. Cookie的使用</strong> </p>
    <p>
      a) 在您未拒绝接受cookies的情况下，积分材料上传系统会在您的计算机上设定或取用cookies，以便您能登录或使用依赖于cookies的积分材料上传系统平台服务或功能。积分材料上传系统使用cookies可为您提供更加周到的个性化服务。
    </p>
    <p>
      b) 您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的积分材料上传系统网络服务或功能。
    </p>
    <p>
      c) 通过积分材料上传系统所设cookies所取得的有关信息，将适用本政策。
    </p>
    <p><strong>6. 信息安全</strong> </p>
    <p>
      a) 积分材料上传系统帐号均有安全保护功能，请妥善保管您的用户名及密码信息。积分材料上传系统将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在 “完善的安全措施 ”。
    </p>
    <p>
      b) 请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是积分材料上传系统用户名及密码发生泄露，请您立即联络浦东新区人才服务中心客服，以便采取相应措施。
    </p>

  </div>
</template>
<script>
export default {}
</script>
<style lang="less" scoped>
.box {
  width: 100%;
  padding: 20px 50px;
  padding-top: 10px;
  max-height: 600px;
  overflow: auto;
}

.a {
  cursor: pointer;
}
.a:hover {
  color: #5cadff;
  text-decoration: underline;
}
p {
  padding-bottom: 15px;
  text-indent: 2rem;
  font-size: 16px;
}
.read {
  text-indent: 0rem;
  color: #2d8cf0;
}
.btn {
  display: flex;
  justify-content: center;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-track {
  background-color: #f5f5f5;
}
::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
}
</style>